var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _vm.apparatus
        ? _c(
            "div",
            {
              staticClass: "card apparatus-card",
              class: { hoverPointer: _vm.isClickable },
              attrs: {
                "header-bg-variant": _vm.getHeaderBGVariant(),
                "header-class": "dashboard-card-header",
                "data-test-hook": "apparatus-clickable-card-apparatus-card"
              },
              on: {
                click: function($event) {
                  return _vm.openErrorModal()
                }
              }
            },
            [
              !_vm.generatorEnrollmentComplete() ||
              ((_vm.isInGracePeriod || _vm.generatorIsDunning()) &&
                !_vm.apparatus.isDealerManaged)
                ? _c("div", [
                    _c(
                      "div",
                      {
                        staticClass:
                          "card-header dashboard-card-header bg-statusWarning"
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "row w-100 no-gutters",
                            attrs: { "data-test-hook": "DisconnectedHeader" }
                          },
                          [
                            _c("div", { staticClass: "float-left col" }, [
                              _vm.generatorIsDunning() || _vm.isInGracePeriod
                                ? _c(
                                    "strong",
                                    {
                                      staticClass: "py-0 my-0",
                                      attrs: { "data-test-hook": "HeaderText" }
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.$t("xUpdateYourPaymentMethod")
                                          ) +
                                          " "
                                      )
                                    ]
                                  )
                                : _c(
                                    "strong",
                                    {
                                      staticClass: "py-0 my-0",
                                      attrs: { "data-test-hook": "HeaderText" }
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.$t(
                                              "xFinishSettingUpYourProduct"
                                            )
                                          ) +
                                          " "
                                      )
                                    ]
                                  )
                            ]),
                            _vm._m(0)
                          ]
                        )
                      ]
                    )
                  ])
                : _vm.generatorDealerSubscriptionExpired()
                ? _c("div", [
                    _c(
                      "div",
                      {
                        staticClass:
                          "card-header dashboard-card-header bg-statusWarning"
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "row w-100 no-gutters",
                            attrs: { "data-test-hook": "NoSubscriptionHeader" }
                          },
                          [
                            _c("div", { staticClass: "float-left col" }, [
                              _c(
                                "strong",
                                {
                                  staticClass: "py-0 my-0",
                                  attrs: { "data-test-hook": "HeaderText" }
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.$t(
                                          "xYourDealerManagedSubscriptionHasExpired"
                                        )
                                      ) +
                                      " "
                                  )
                                ]
                              )
                            ]),
                            _vm._m(1)
                          ]
                        )
                      ]
                    )
                  ])
                : _vm.hsbHasDealerAndActivePremiumSub()
                ? _c("div", [
                    _c(
                      "div",
                      {
                        staticClass:
                          "card-header dashboard-card-header bg-statusWarning"
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "row w-100 no-gutters",
                            attrs: {
                              "data-test-hook":
                                "GeneratorInDealerPlanAndPremiumPlan"
                            }
                          },
                          [
                            _c("div", { staticClass: "float-left col" }, [
                              _c(
                                "strong",
                                {
                                  staticClass: "py-0 my-0",
                                  attrs: { "data-test-hook": "HeaderText" }
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.$t(
                                          "xYourAccountNeedsAttentionHeader"
                                        )
                                      ) +
                                      " "
                                  )
                                ]
                              )
                            ]),
                            _vm._m(2)
                          ]
                        )
                      ]
                    )
                  ])
                : _vm.basicHSBWithExistingSubscription()
                ? _c("div", [
                    _c(
                      "div",
                      {
                        staticClass:
                          "card-header dashboard-card-header bg-statusWarning"
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "row w-100 no-gutters",
                            attrs: { "data-test-hook": "NotCoveredGenerator" }
                          },
                          [
                            _c("div", { staticClass: "float-left col" }, [
                              _c(
                                "strong",
                                {
                                  staticClass: "py-0 my-0",
                                  attrs: { "data-test-hook": "HeaderText" }
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.$t(
                                          "xYourAccountNeedsAttentionHeader"
                                        )
                                      ) +
                                      " "
                                  )
                                ]
                              )
                            ]),
                            _vm._m(3)
                          ]
                        )
                      ]
                    )
                  ])
                : _vm._e(),
              _c(
                "div",
                { staticClass: "yellowstone-card-body" },
                [
                  _c("div", { staticClass: "row d-flex" }, [
                    _c("div", { staticClass: "col-4" }, [
                      _c("img", {
                        staticClass: "img-fluid",
                        attrs: {
                          src: _vm.apparatus.heroImageUrl,
                          "data-test-hook": "ApparatusHeroImg",
                          alt: "Hero Image"
                        }
                      })
                    ]),
                    _c("div", { staticClass: "pt-4 col-8" }, [
                      _c("div", { staticClass: "row" }, [
                        _c(
                          "div",
                          {
                            staticClass: "ellipsis-overflow mb-2 col",
                            attrs: { "data-test-hook": "ApparatusAddress" }
                          },
                          [
                            _vm._v(
                              " " + _vm._s(_vm.apparatus.localizedAddress) + " "
                            )
                          ]
                        )
                      ]),
                      _c("div", { staticClass: "row" }, [
                        _c("div", { staticClass: "col" }, [
                          _c(
                            "h2",
                            {
                              staticClass: "pb-1 mb-0",
                              attrs: { "data-test-hook": "ApparatusName" }
                            },
                            [_vm._v(" " + _vm._s(_vm.apparatus.name) + " ")]
                          )
                        ])
                      ])
                    ])
                  ]),
                  _c(
                    "b-alert",
                    {
                      staticClass: "alert alert-info px-3 pt-3 pb-3",
                      attrs: { show: "" }
                    },
                    [
                      _c("div", { staticClass: "d-flex align-items-start" }, [
                        _c("div", { staticClass: "flex-shrink-0" }, [
                          _c("i", { staticClass: "far fa-circle-exclamation" })
                        ]),
                        _c(
                          "div",
                          {
                            staticClass: "ml-2",
                            staticStyle: { "font-weight": "normal" }
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(_vm.$t("xDownloadAppToMonitorText")) +
                                " "
                            ),
                            _c("MobileDownloadLinkButtons")
                          ],
                          1
                        )
                      ])
                    ]
                  )
                ],
                1
              )
            ]
          )
        : _vm._e(),
      _vm.apparatus && _vm.apparatus.apparatusId
        ? _c(
            "div",
            {
              staticClass: "modal fade show",
              attrs: {
                id:
                  "basic-gen-with-existing-subscription" +
                  _vm.apparatus.apparatusId,
                role: "dialog"
              }
            },
            [
              _c("div", { staticClass: "modal-dialog modal-dialog-centered" }, [
                _c("span", { attrs: { tabindex: "0" } }),
                _c(
                  "div",
                  { staticClass: "modal-content", attrs: { tabindex: "-1" } },
                  [
                    _c("header", { staticClass: "modal-header" }, [
                      _c(
                        "div",
                        {
                          staticClass: "row w-100 no-gutters align-items-center"
                        },
                        [
                          _c("div", { staticClass: "col" }, [
                            _c("h2", { staticClass: "modal-title" }, [
                              _c("i", {
                                staticClass:
                                  "far fa-exclamation-triangle colorOrange mr-1"
                              }),
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.$t("xYourAccountNeedsAttentionHeader")
                                  ) +
                                  " "
                              )
                            ])
                          ]),
                          _c("div", { staticClass: "float-right col-auto" }, [
                            _c(
                              "button",
                              {
                                staticClass:
                                  "btn btn-icon-button--gray btn-icon-button",
                                attrs: { type: "button" },
                                on: {
                                  click: function($event) {
                                    return _vm.closeBasicGenWithExistingSubscriptionModal()
                                  }
                                }
                              },
                              [_c("i", { staticClass: "fas fa-times" })]
                            )
                          ])
                        ]
                      )
                    ]),
                    _c("div", { staticClass: "modal-body" }, [
                      _c("div", { staticClass: "row" }, [
                        _c("div", { staticClass: "col" }, [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.$t("xGeneratorNotCoveredUnderPremiumPlan")
                              ) +
                              " "
                          )
                        ])
                      ])
                    ]),
                    _c("ModalFooter", [
                      _c(
                        "button",
                        {
                          class: _vm.apparatusesOverLimit
                            ? "btn btn-primary"
                            : "btn btn-secondary",
                          attrs: { type: "button" },
                          on: {
                            click: function($event) {
                              return _vm.goToServiceOps()
                            }
                          }
                        },
                        [_vm._v(" " + _vm._s(_vm.$t("xFindADealer")) + " ")]
                      ),
                      !_vm.apparatusesOverLimit
                        ? _c(
                            "button",
                            {
                              staticClass: "btn btn-primary",
                              attrs: { type: "button" },
                              on: {
                                click: function($event) {
                                  _vm.closeBasicGenWithExistingSubscriptionModal(),
                                    _vm.$emit(
                                      "openHSBEnrollmentFlow",
                                      _vm.apparatus.apparatusId,
                                      _vm.apparatus.modelNumber
                                    )
                                }
                              }
                            },
                            [_vm._v(" " + _vm._s(_vm.$t("xUpgradeNow")) + " ")]
                          )
                        : _vm._e()
                    ])
                  ],
                  1
                )
              ])
            ]
          )
        : _vm._e(),
      _vm.apparatus && _vm.apparatus.apparatusId
        ? _c(
            "div",
            {
              staticClass: "modal fade show",
              attrs: {
                id: "dealer-managed-sub-expired" + _vm.apparatus.apparatusId,
                role: "dialog"
              }
            },
            [
              _c(
                "div",
                {
                  staticClass: "modal-dialog modal-dialog-centered modal-lg",
                  staticStyle: { width: "720px" }
                },
                [
                  _c("span", { attrs: { tabindex: "0" } }),
                  _c(
                    "div",
                    { staticClass: "modal-content", attrs: { tabindex: "-1" } },
                    [
                      _c("header", { staticClass: "modal-header" }, [
                        _c(
                          "div",
                          {
                            staticClass:
                              "row w-100 no-gutters align-items-center"
                          },
                          [
                            _c("div", { staticClass: "col" }, [
                              _c("h2", { staticClass: "modal-title" }, [
                                _c("i", {
                                  staticClass:
                                    "far fa-exclamation-triangle colorOrange mr-1"
                                }),
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.$t(
                                        "xYourDealerManagedSubscriptionHasExpired"
                                      )
                                    ) +
                                    " "
                                )
                              ])
                            ]),
                            _c("div", { staticClass: "float-right col-auto" }, [
                              _c(
                                "button",
                                {
                                  staticClass:
                                    "btn btn-icon-button--gray btn-icon-button",
                                  attrs: { type: "button" },
                                  on: {
                                    click: function($event) {
                                      return _vm.closeDealerModal()
                                    }
                                  }
                                },
                                [_c("i", { staticClass: "fas fa-times" })]
                              )
                            ])
                          ]
                        )
                      ]),
                      _c("div", { staticClass: "modal-body" }, [
                        _c("div", { staticClass: "row" }, [
                          _vm.preferredDealer
                            ? _c("div", { staticClass: "col" }, [
                                _c("p", { staticClass: "mb-4" }, [
                                  _vm._v(
                                    " " +
                                      _vm._s(_vm.$t("xContactYourDealer")) +
                                      " "
                                  )
                                ]),
                                _vm.preferredDealer.name
                                  ? _c(
                                      "p",
                                      {
                                        attrs: {
                                          "data-test-hook": "DealerAddress1"
                                        }
                                      },
                                      [
                                        _c("strong", [
                                          _vm._v(
                                            _vm._s(_vm.preferredDealer.name)
                                          )
                                        ])
                                      ]
                                    )
                                  : _vm._e(),
                                _vm.preferredDealer.topLineAddress
                                  ? _c(
                                      "p",
                                      {
                                        attrs: {
                                          "data-test-hook": "DealerAddress1"
                                        }
                                      },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.preferredDealer.topLineAddress
                                            ) +
                                            " "
                                        )
                                      ]
                                    )
                                  : _vm._e(),
                                _vm.preferredDealer.bottomLineAddress
                                  ? _c(
                                      "p",
                                      {
                                        attrs: {
                                          "data-test-hook": "DealerAddress2"
                                        }
                                      },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.preferredDealer
                                                .bottomLineAddress
                                            ) +
                                            " "
                                        )
                                      ]
                                    )
                                  : _vm._e(),
                                _vm.preferredDealer.phoneNumber
                                  ? _c(
                                      "p",
                                      {
                                        attrs: {
                                          "data-test-hook": "DealerPhoneNumber"
                                        }
                                      },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm._f("phone")(
                                                _vm.preferredDealer.phoneNumber
                                              )
                                            ) +
                                            " "
                                        )
                                      ]
                                    )
                                  : _vm._e(),
                                _vm.preferredDealer.email
                                  ? _c(
                                      "a",
                                      {
                                        attrs: {
                                          href:
                                            "mailto:" +
                                            _vm.preferredDealer.email
                                        }
                                      },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(_vm.preferredDealer.email) +
                                            " "
                                        )
                                      ]
                                    )
                                  : _vm._e()
                              ])
                            : _vm._e()
                        ])
                      ])
                    ]
                  )
                ]
              )
            ]
          )
        : _vm._e(),
      _vm.generatorIsDunning() || _vm.isInGracePeriod
        ? _c("UpdateCreditCardModal", {
            attrs: {
              existingPaymentInfo: _vm.paymentInfo,
              accountProfile: _vm.accountProfile,
              apparatusId: _vm.apparatusInfo.apparatusId,
              subscriptionStatus:
                this.subscription &&
                this.subscription[0] &&
                this.subscription[0].value &&
                this.subscription[0].value.status
                  ? this.subscription[0].value.status
                  : null
            }
          })
        : _vm._e(),
      _vm.apparatus && _vm.hsbSubscriptionDetails
        ? _c("MultipleChargesModal", {
            attrs: {
              apparatus: _vm.apparatus,
              currentPremiumSubscription: _vm.hsbSubscriptionDetails
            }
          })
        : _vm._e(),
      _vm.apparatus
        ? _c("MobileSubscriptionModal", {
            attrs: {
              modalId: `mobile-sub-modal-${_vm.apparatus.apparatusId}`,
              store: _vm.mobileSubscriptionStore
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "float-right mr-0 pr-0 col-auto" }, [
      _c("i", { staticClass: "fa-solid fa-arrow-right" })
    ])
  },
  function() {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "float-right mr-0 pr-0 col-auto" }, [
      _c("i", { staticClass: "fa-solid fa-arrow-right" })
    ])
  },
  function() {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "float-right mr-0 pr-0 col-auto" }, [
      _c("i", { staticClass: "fa-solid fa-arrow-right" })
    ])
  },
  function() {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "float-right mr-0 pr-0 col-auto" }, [
      _c("i", { staticClass: "fa-solid fa-arrow-right" })
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }